import * as React from 'react';
import './PortableLayout.css';
import { useSelector } from 'react-redux';
import PortableHeader from '../PortableHeader/PortableHeader';
import PortableStats from '../PortableStats/PortableStats';
import { selectApiCallSpinner } from '../../../App/selectors';
import PortableLoader from '../../../../components/PortableLoader/PortableLoader';
import { selectMiningErrorPokersiteId, selectShowMiningError } from '../../selectors';
import Flex from '../../../../components/Flex/Flex';
import Text from '../../../../components/Text/Text';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { readPortableZoomPercent } from '../../../../components/ZoomApp/zoomDocument';

const PortableLayout = React.memo(() => {
  const initialZoom = React.useMemo(() => readPortableZoomPercent(), []);
  const { t } = useTranslation('translation');

  const apiCallSpinner = useSelector(selectApiCallSpinner);
  const showMiningError = useSelector(selectShowMiningError);
  const miningErrorPokersiteId = useSelector(selectMiningErrorPokersiteId);

  return (
    <section className="PortableLayout" style={{ zoom: `${initialZoom}%` }}>
      {apiCallSpinner && <PortableLoader />}
      <PortableHeader />
      <PortableStats />
      {showMiningError &&
        (miningErrorPokersiteId === 1 ? (
          <Flex vertical gap={8}>
            <Text>{t('mining_error_text_1')}</Text>
            <Text>{t('mining_error_text_2')}</Text>
            <Text>{t('mining_error_text_4')}</Text>
            <Text>
              C ценами можно ознакомиться в разделе <Link to="/subscription">подписка</Link>.
            </Text>
            <Link target="_blank" to="https://t.me/fishh_support">
              https://t.me/fishh_support
            </Link>
          </Flex>
        ) : (
          <Flex vertical gap={8}>
            <Text>
              {t('subscription_error_1')}{' '}
              <Link target="_blank" to="https://t.me/fishh_support">
                https://t.me/fishh_support
              </Link>
            </Text>
            <Text>
              C ценами можно ознакомиться в разделе <Link to="/subscription">подписка</Link>.
            </Text>
            <Text>{t('subscription_error_2')}</Text>
          </Flex>
        ))}
    </section>
  );
});

export default PortableLayout;
